
<template>
  <div ref="container" class="d-flex flex-fill" v-if="show">
    <div v-if="mode === 'view'">{{ }}</div>
    <div v-if="mode === 'edit' || mode === 'create'" class="d-flex flex-fill">
      <div class="input-group d-flex flex-fill">
       <!-- <div class="input-group-prepend custom" id="add-account" @click="openAccountTitleTree">
          <div class="input-group-text">
            <span>+</span>
          </div>
        </div>-->
        <vs-select
          ref="selectAccount"
          :isHeader="true"
          :data="patternNames"
          :selectedVal="model"
          :header="{label:'name'}"
          :mode="'edit'"
          v-model="account"
          @onChange="onValueChanged"
        ></vs-select>
      </div>
    </div>


    <!-- <b-modal ref="accountsModal" title="انتخاب حساب" size="lg" ok-only ok-title="تایید">
    </b-modal>-->
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from "vuex";
  import AccountsTitlesModal from "../components/AccountsTitlesModal.vue";
  import Vue from "vue";
  import VsSelect from "../_framework/VsSelect";
  import BaseService from "../_framework/api/BaseService.js";
  import JQuery from "jquery";
  import EventBus from "../_framework/bus.js";

  export default {
    name: "account-title-select",
    props: {
      data: null,
      header: null,
      headerKey: null,
      mode: null,
      placeholder: null,
      type: null,
      row: null,

    },
    components: {
      AccountsTitlesModal,
      VsSelect,

    },
    data() {
      return {
        show: true,
        allData: [],
        account: null,
        accountsTitles: [],
        model: null,
        lastValue: "",
        journals: [],
        _accountTitle: null,
        patternNames: [],
        patternId: null
      };
    },
    mounted() {
      this.patternsList();

      /*if (this.$route.query.id) {

      }
      if (this.mode === "create") {
        this.model = null;
      }*/
    },
    methods: {
      patternsList() {
        new BaseService('Patterns', '/GetAllPatterns/').getList().then((response) => {
          console.log(response.data);
          this.patternNames = response.data;
          //this.patternNames = response.data.name;
         /* for(let item  of response.data) {
            this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", item);
          }*/
          //this.tableParams.list = response.data;
        }).catch((error) => {
          console.log(error)
        }).then(() => {

        });
      },
      setModel(accountTitle) {
       /* let _accountTitle = this._accountTitle || accountTitle;
        if (this.mode !== "create" && _accountTitle) {
          this.model = JSON.parse(JSON.stringify(_accountTitle));
          this.model.title = _accountTitle.code + " " + _accountTitle.title;
        }
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);*/
      },
      openAccountTitleTree() {
    /*    let accountsTitlesModal = Vue.extend(AccountsTitlesModal);
        let modal = new accountsTitlesModal({});
        let model = null;
        modal.$mount();
        this.$refs.container.appendChild(modal.$el);
        modal.openModal();
        setTimeout(() => {
          modal.openModal();
        }, 500);
        modal.$on("selectAccountTitle", data => {
          model = JQuery.extend({}, data);
          model.title = data.code + " " + data.title;
        });
        modal.$on("dblSelectAccountTitle", (data, ancestors) => {
          model = JQuery.extend({}, data);
          model.ancestors = ancestors;
          model.title = data.code + " " + data.title;
        });
        modal.$on("onOk", () => {
          if (model) {
            this.model = model;
          }
          // this.onValueChanged(this.model);
        });*/
      },
      findById(id) {
        /*let item = this.allData.find(d => {
          return d.id === id;
        });
        return item;*/
      },
      onValueChanged(val) {
        // console.log(val);
        this.patternId = val.id;
        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED");
       /* this.$emit("dataChanged", this.headerKey, val);
        EventBus.$emit("onSelectAccountTitle", val);*/
      },
      onKeyDown(event) {
        /*if (this.type === "number" && event.key === "e") {
          event.preventDefault();
          return;
        }

        this.$nextTick(() => {
          if (event.target.value === this.lastValue) {
            return;
          }

          this.onValueChanged(event.target.value);
          this.lastValue = event.target.value;
        });*/
      }
    },
    computed: {
      ...mapState(["selectedRows", "currentService", "vsTableFeed"])
    },
    watch: {
    /*  mode(val) {
        this.setModel();
      },
      _accountTitle(val) {
        let _mode = this.mode;
        this.mode = null;
        this.mode = _mode;
      }*/
    }
  };
</script>

<style scoped>
  /* .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  } */
  /* .v-select .dropdown-toggle input {
    width: 100% !important;
  }
  .v-select > div {
    width: 100% !important;
  } */
  #add-account:hover {
    cursor: pointer;
  }
</style>
